import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import StaffPortalView from './StaffPortal';

/**
 * Staff Dashboard tab — a staff picker that renders the individual StaffPortal dashboard in
 * manager view. Extracted from StaffManagement so each tab lives in its own file.
 */
export default function StaffDashboardTab({ staff = [], dashboardStaffId, setDashboardStaffId }) {
  return (
    <div className="space-y-4">
      {/* Staff picker */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <LayoutDashboard size={16} className="text-primary-600" /> View Staff Dashboard
        </label>
        <select
          value={dashboardStaffId}
          onChange={(e) => setDashboardStaffId(e.target.value)}
          className="w-full sm:w-72 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-primary-100 focus:border-primary-500"
        >
          <option value="">— Select a staff member —</option>
          {[...staff].sort((a, b) => {
            // Active staff first, then terminated
            const aActive = a.employment_status !== 'terminated' ? 0 : 1;
            const bActive = b.employment_status !== 'terminated' ? 0 : 1;
            if (aActive !== bActive) return aActive - bActive;
            return (a.first_name || '').localeCompare(b.first_name || '');
          }).map(s => (
            <option key={s.id} value={s.id}>
              {s.full_name || `${s.first_name} ${s.last_name}`.trim()}
              {s.employment_status === 'terminated' ? ' (Former)' : s.designation ? ` · ${s.designation}` : ''}
            </option>
          ))}
        </select>
      </div>
      {/* Reuse StaffPortal component with manager-supplied staff ID */}
      {dashboardStaffId ? (
        <StaffPortalView staffId={dashboardStaffId} managerView />
      ) : (
        <div className="bg-white rounded-xl border border-dashed border-gray-200 p-12 text-center text-sm text-gray-400">
          Select a staff member above to view their dashboard
        </div>
      )}
    </div>
  );
}
